import PropTypes from 'prop-types';
import { useState } from 'react';
import { ReactComponent as ChevronDown } from '@/assets/svgs/chevron-down.svg';

export const AccordionCard = ({
	title,
	children,
	defaultOpen = true,
	className = ''
}) => {
	const [isCollapsed, setIsCollapsed] = useState(!defaultOpen);

	return (
		<div className={`accordion-card ${className}`}>
			<div className="accordion-card__header">
				<button
					type="button"
					className={`accordion-card__toggle ${isCollapsed ? 'collapsed' : ''}`}
					onClick={() => setIsCollapsed(!isCollapsed)}
					aria-label={isCollapsed ? 'Expand' : 'Collapse'}
					aria-expanded={!isCollapsed}
				>
					<ChevronDown />
				</button>
				<div className="accordion-card__title">
					{title}
				</div>
			</div>
			<div className={`accordion-card__content ${isCollapsed ? 'collapsed' : ''}`}>
				{children}
			</div>
		</div>
	);
};

AccordionCard.propTypes = {
	title: PropTypes.node.isRequired,
	children: PropTypes.node.isRequired,
	defaultOpen: PropTypes.bool,
	className: PropTypes.string
};

export default AccordionCard;
